export default __webpack_public_path__ + "static/media/logo-white.fd2de4ee.svg";